import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_COUNTRIES_KEY } from '@/keys';

type Country = {
  id: number;
  isoCode: string | null;
};

async function getCountries(): Promise<Country[]> {
  const response = await api.get<Country[]>('/countries');

  return response.data;
}

export function useGetCountries(): UseQueryResult<Country[], Error> {
  return useQuery({
    queryKey: GET_COUNTRIES_KEY,
    queryFn: getCountries,
  });
}
